// ==========================================================================
// DHC Lip Series - Main JavaScript
// ==========================================================================

console.log('DHC Lip Series initialized');

// Import modules
import './header';
import './modules/modal';
import './modules/accordion';
import './modules/carousel';
import './modules/diagnosis';
import './modules/kv';
import './modules/faq';
import './modules/flor-de-aceite';
import './modules/labo';
import './modules/products';
import './modules/products-itempoint';
import './modules/color-product-modal';
import './modules/medicated-product-modal';
import './modules/labo-modal';
import './modules/stores';
import './modules/footer-scroll';

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', () => {
	console.log('DOM Content Loaded');

	// Initialize header scroll behavior
	initHeaderScroll();
});

// Smooth Scroll
// NOTE: ハッシュリンク(href="#xxx")のスクロールは header.js の HeaderNav が
// 固定ヘッダー分のオフセットを考慮して処理するため、ここでは登録しない。
// (二重登録すると scrollIntoView がオフセットを無視して上書きしてしまう)

// Header Scroll Behavior
function initHeaderScroll() {
	const header = document.querySelector('.header');
	if (!header) return;

	let lastScroll = 0;

	window.addEventListener('scroll', () => {
		const currentScroll = window.pageYOffset;

		if (currentScroll > 100) {
			header.classList.add('is-scrolled');
		} else {
			header.classList.remove('is-scrolled');
		}

		lastScroll = currentScroll;
	});
}
